import { z } from 'zod';
import { email, globalRole, isoDateTime, uuid } from './primitives.js';
export const authUser = z.object({
    id: uuid,
    email,
    name: z.string(),
    globalRole,
    isActive: z.boolean(),
    lastLoginAt: isoDateTime.nullable(),
    createdAt: isoDateTime,
});
/**
 * What the SPA needs on boot: who you are, and the coarse capabilities that
 * decide which navigation exists. Fine-grained checks stay server-side; this is
 * only for hiding chrome the user could not use anyway.
 */
export const meResponse = z.object({
    user: authUser,
    capabilities: z.object({
        isAdmin: z.boolean(),
        /** Assigned to at least one session, or a capstone — so /admin is reachable. */
        isInstructor: z.boolean(),
        /** Manages at least one course as a course admin — so /admin is reachable. */
        isCourseAdmin: z.boolean(),
        /** May write guides. */
        isGuideWriter: z.boolean(),
        enrolledCourseCount: z.number().int(),
        assignedSessionCount: z.number().int(),
        assignedCapstoneCount: z.number().int(),
    }),
    /**
     * Set while an admin is viewing the platform as this user ("View as"):
     * `user` and `capabilities` are the viewed user's, and this is the admin.
     */
    viewAsBy: z
        .object({ id: uuid, name: z.string(), email })
        .nullable(),
});
/**
 * "View as": an admin sends this header, naming a user, and every request is
 * answered as that user would see it. Read-only — the API refuses anything but
 * GET while it is set.
 */
export const VIEW_AS_HEADER = 'x-lp-view-as';
export const startViewAsRequest = z.object({ userId: uuid });
export const loginStartQuery = z.object({
    redirectTo: z.string().max(512).optional(),
});
export const devLoginRequest = z.object({
    email,
});
export const authConfigResponse = z.object({
    /** 'entra' in any real deployment; 'dev' only when DEV_AUTH_ENABLED. */
    providers: z.array(z.enum(['entra', 'dev'])),
    tenantName: z.string(),
    allowedDomain: z.string(),
    /** Seeded identities offered by the dev-login picker. Empty unless dev auth is on. */
    devAccounts: z
        .array(z.object({ email, name: z.string(), label: z.string() }))
        .default([]),
});
export const sessionResponse = z.object({
    accessToken: z.string(),
    expiresInSec: z.number().int(),
    user: authUser,
});
//# sourceMappingURL=auth.js.map